import { approvalsModule } from "./approvals";
import { calendarModule } from "./calendar";
import { clientsTagsModule } from "./clients-tags";
import { dashboardModule } from "./dashboard";
import { expensesModule } from "./expenses";
import { invoicesModule } from "./invoices";
import { kioskActivityModule } from "./kiosk-activity";
import { projectsTasksModule } from "./projects-tasks";
import { publicApiModule } from "./public-api";
import { reportsOtherModule } from "./reports-other";
import { reportsSummaryDetailedModule } from "./reports-summary-detailed";
import { schedulingModule } from "./scheduling";
import { settingsModule } from "./settings";
import { shellAuthModule } from "./shell-auth";
import { teamModule } from "./team";
import { timeOffModule } from "./time-off";
import { timeTrackerModule } from "./time-tracker";
import { timesheetModule } from "./timesheet";
import type { AppModule } from "./types";

export type {
  AppModule,
  FlyoutGroup,
  LayoutKey,
  ModuleDefinition,
  RouteHandle,
  SettingsSection,
  ShellContext,
  SidebarEntry,
  SidebarId,
  SidebarSection,
} from "./types";
export { LAYOUT_KEYS, SIDEBAR_IDS } from "./types";

// Append-only: each feature module adds one import and one entry, so parallel branches merge cleanly.
export const appModules: AppModule[] = [
  shellAuthModule,
  timeTrackerModule,
  clientsTagsModule,
  projectsTasksModule,
  teamModule,
  settingsModule,
  timeOffModule,
  approvalsModule,
  expensesModule,
  timesheetModule,
  calendarModule,
  kioskActivityModule,
  schedulingModule,
  invoicesModule,
  dashboardModule,
  reportsSummaryDetailedModule,
  reportsOtherModule,
  publicApiModule,
];
